import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: () => import('@/views/CoursePage'),
        hidden: true,
        meta: {title: "首页"}
    },
    {
        path: '/course',
        component: () => import('@/views/Home'),
        hidden: true,
        meta: {title: "课程"}
    },
    {
        path: '/campus',
        component: () => import('@/views/CampusPage'),
        hidden: true,
        meta: {title: "校区"}
    },
]
const router = new VueRouter({
    mode: 'hash',
    routes
});
router.beforeEach((to, from, next) => {
    // 浏览器标题
    document.title = to.meta.title||'竞争力一对一';
    next()
});

export default router
